import { createContext, useContext } from "react"

export type PluginActionsContext = {
    displayName: string
    iconUrl: string | undefined
}
export const PluginActionsContext = createContext({} as PluginActionsContext)

export const usePluginActionsContext = () => {
    const context = useContext(PluginActionsContext) as PluginActionsContext
    return context
}
